import { useGetUnsettlementsReasonsQuery } from '@bo-services/unsettlementsApi';

export const useUnsettlementsReasons = () => {
  const {
    data: response,
    isFetching,
    isError,
    isLoading,
    isSuccess
  } = useGetUnsettlementsReasonsQuery();

  return {
    data: response,
    isFetching,
    isLoading,
    isSuccess,
    isError
  };
};
